import { GraphQLClient } from "graphql-request";

import { env } from "@/env";
import { createFetchCacheConfig } from "@/libs/cache-config/fetch/createFetchCacheConfig";
import { getMagentoStoreHandler } from "@/libs/commerce/getMagentoStore/getMagentoStoreHandler";

import type { Sdk } from "./__generated__/";
import { getSdk } from "./__generated__/";

import type { GraphqlClientOptions } from "./types";

const endpoint = env.magentoGraphqlEndpoint;

const createMagentoGraphqlClient = (
  options?: GraphqlClientOptions & {
    locale?: string;
    isTrialStoreCode?: boolean;
  }
) => {
  const { locale, isTrialStoreCode = false, ...clientOptions } = options || {};

  const customFetch: typeof fetch = async (url, config) => {
    const getMagentoStore = getMagentoStoreHandler(isTrialStoreCode);
    const storeViewCode = await getMagentoStore(locale);

    const headers = new Headers(config?.headers);
    headers.set("Store", storeViewCode);

    return fetch(url, {
      ...config,
      headers,
      ...createFetchCacheConfig({ tags: ["magento-fetch-cache-tag"] }),
    });
  };

  return new GraphQLClient(endpoint, {
    fetch: customFetch,
    ...clientOptions,
  });
};

const createTypedMagentoGraphqlClient = (
  options?: GraphqlClientOptions & {
    locale?: string;
    isTrialStoreCode?: boolean;
  }
): Sdk => {
  const client = createMagentoGraphqlClient(options);

  return getSdk(client);
};

export { createMagentoGraphqlClient, createTypedMagentoGraphqlClient };
